<template>
  <!-- Name will be something like activity_tasks -->
  <!-- Only loop through arrays longer than 0, with at least one child that is an object -->
  <div
    v-if="
      category !== null &&
      category.constructor.name === 'Array' &&
      category.length > 0 &&
      category.some((child) => child.constructor.name === 'Object')
    "
    class="col-span-full grid grid-cols-12 gap-x-4 gap-y-5 mb-10"
  >

    <div
      class="col-span-full uppercase text-indigo-600 text-base mx-5 md:mx-10"
    >
      {{
        name.includes('tasks')
          ? 'Tâches Principales'
          : name.includes('comportements')
          ? 'Comportement / Aptitudes'
          : name.includes('connaissances')
          ? 'Connaissances associées'
          : name.includes('pratiques')
          ? 'Pratiques Professionnelles'
          : name
      }}
    </div>
    <CheckboxIndigo
      v-if="getCriteria(true).length > 1 && getCriteria(true).length < 6"
      class="ml-10 col-span-full"
      libelle="Mode simplifié"
      :value="jauge"
      @input="toggleJauge"
    >
    </CheckboxIndigo>
    <div v-if="category.length > 0" class="col-span-full">

      <!-- display as a table -->
      <div v-if="!$isMobile()">
        <div class="text-lg text-gray-600 grid grid-cols-10 gap-x-4 mx-10">
          <div class="col-span-3">
            {{
              name.includes('tasks')
                ? 'Tâches'
                : name.includes('comportements')
                ? 'Capacités / Aptitudes...'
                : name.includes('connaissances')
                ? 'Théoriques, procédurales...'
                : name.includes('pratiques')
                ? 'Être capable de...'
                : name
            }}
          </div>
          <div class="col-span-2 text-center">Auto-évaluation</div>
          <div
            class="col-span-2 text-center"
            :class="{ hidden: idPass == idUser }"
          >
            <span :class="{ hidden: historyMode }">Dernière eval. ref.</span>
          </div>
          <div class="col-span-2 text-center">
            <span :class="{ hidden: idPass == idUser }"
              >Nouvelle eval. ref.</span
            >
          </div>
          <div class="col-span-1 text-center">
            <span :class="{ hidden: idPass == idUser }">Comm.</span>
          </div>

          <!--
                        --  hiddenFields contains all the variables responsible for hiding or showing the fields, specific variable names are determined
                        --  dynamically from a prefix (auto_ / last_) and the loop iterator
                    -->
          <div
            class="col-start-4 col-span-2 flex items-center justify-center"
            :class="{
              hidden: idPass == idUser || historyMode,
              'cursor-help': !$can('comppro_auto_eval_read', idPass),
              'cursor-pointer': $can('comppro_auto_eval_read', idPass),
            }"
            @click.stop="
              $can('comppro_auto_eval_read', idPass)
                ? hide('auto_' + name)
                : null
            "
            :title="
              $can('comppro_auto_eval_read', idPass)
                ? null
                : 'Permission manquante'
            "
          >
            <icon
              :name="hiddenFields['auto_' + name] ? 'eye-off' : 'eye'"
              class="h-3 w-4 text-pink-600"
            />
            <span class="ml-3 text-sm select-none">
              {{ hiddenFields['auto_' + name] ? 'Afficher' : 'Masquer' }}
            </span>
          </div>
          <div
            class="col-span-2 flex items-center justify-center cursor-pointer"
            :class="{ hidden: idPass == idUser || historyMode }"
            @click.stop="hide('last_' + name)"
          >
            <icon
              :name="hiddenFields['last_' + name] ? 'eye-off' : 'eye'"
              class="h-3 w-4 text-pink-600"
            />
            <span class="ml-3 text-sm select-none">
              {{ hiddenFields['last_' + name] ? 'Afficher' : 'Masquer' }}
            </span>
          </div>
        </div>

        <div
          v-for="(item, index) in category"
          :key="index"
          class="odd:bg-indigo-100 odd:bg-opacity-50"
        >
          <!-- BEGIN Informations on accordion -->
          <div
            class="h-auto py-5 xl:min-h-24 2xl:min-h-32 grid grid-cols-10 gap-x-4 place-content-center items-center cursor-default mx-10"
          >
            <div
              class="col-span-full md:col-span-3 text-base font-normal flex flex-col items-start gap-3"
            >
              <TextToSpeech :speak="item.name"></TextToSpeech>

              <!-- Only display the icon for tasks -->
              <!-- <icon v-if="name.includes('tasks')" name="camera" class="text-pink-600"/> -->
              {{ item.name }}
            </div>

            <AnswerJauge
              v-if="!hiddenFields['auto_' + name] && jauge"
              class="md:col-span-2"
              :disabled="false"
              :criteria="getCriteria(true)"
              :reduced="false"
              :selected="form.items.activities[num][name][index].auto"
              @select="
                (newValue) => {
                  setAutoEvaluation(
                    num,
                    name,
                    index,
                    newValue !== undefined ? getCriteria(true)[newValue].value : undefined
                  );
                }
              "
            ></AnswerJauge>

            <input-select
              v-if="(!hiddenFields['auto_' + name] || historyMode) && !jauge"
              class="md:col-span-2 md:place-self-center"
              :name="num + name + index + 'auto'"
              :value="form.items.activities[num][name][index].auto"
              :datas="getCriteria(true)"
              @input="
                (newValue) => {
                  setAutoEvaluation(num, name, index, newValue);
                }
              "
              :disabled="autoEvalEditable || historyMode"
              libelle=""
            />
            <div
              v-if="hiddenFields['auto_' + name]"
              class="col-span-full md:col-span-2"
            />

            <AnswerJauge
              v-if="idPass == idUser && !jauge"
              :disabled="false"
              :criteria="getCriteria(true)"
              :reduced="false"
              :selected="form.items.activities[num][name][index].auto"
              @select="
                (newValue) => {
                  setAutoEvaluation(
                    num,
                    name,
                    index,
                    newValue !== undefined ? getCriteria(true)[newValue].value : undefined
                  );
                }
              "
            ></AnswerJauge>

            <input-text
              v-if="
                !historyMode &&
                !hiddenFields['last_' + name] &&
                idPass != idUser && false
              "
              class="md:col-span-2 md:place-self-center"
              :value="
                (((latestEval || {}).items || {}).activities || []).length > 0
                  ? (
                      (((((latestEval || {}).items || {}).activities || [])[
                        num
                      ] || {})[name] || [])[index] || {}
                    ).value === null
                    ? 'Non noté'
                    : (
                        (((((latestEval || {}).items || {}).activities || [])[
                          num
                        ] || {})[name] || [])[index] || {}
                      ).value || 'Pas d\'évaluation récente'
                  : 'Pas d\'évaluation récente'
              "
              :disabled="true"
              libelle=""
            />
            <div v-else class="col-span-full md:col-span-2" />

            <input-select
              class="md:col-span-2 md:place-self-center"
              v-if="idPass != idUser"
              :necessary="isNecessary"
              :name="num + name + index"
              :value="form.items.activities[num][name][index].value"
              :datas="getCriteria(false)"
              @input="
                (newValue) => {
                  setReferentEvaluation(num, name, index, newValue);
                }
              "
              :disabled="idPass == idUser || historyMode"
              libelle=""
            />
            <div v-else class="col-span-full md:col-span-2" />

            <icon-comment
              v-if="idPass != idUser"
              :name="'comment-' + num + '-' + name + '-' + index"
              :value="form.items.activities[num][name][index].comment"
              @input="
                (newValue) => {
                  setComment(num, name, index, newValue);
                }
              "
              class="md:col-span-1 cursor-pointer md:place-self-center"
              :disabled="historyMode"
            />
            <div v-else class="col-span-full md:col-span-1" />
          </div>
        </div>
      </div>
      <!-- END display as a table -->

      <!-- display on rows (for MOBILE devices) -->
      <div v-if="$isMobile()" class="mx-5">
        <div
          v-for="(item, index) in category"
          :key="index"
          class="odd:bg-indigo-100 odd:bg-opacity-50"
        >
          <div
            class="h-auto py-5 min-h-16 lg:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center"
            :class="{
              'bg-indigo-200 border-l-2 border-indigo-600':
                itemDisplayed == index,
            }"
            @click="displayItem(index, item.name)"
            :id="'category' + item.name + index"
          >
            <div
              class="col-span-2 text-pink-600 justify-self-center flex flex-col justify-around"
            >
              <icon
                class="transform transition-transform ease-in-out duration-300"
                :class="{ 'rotate-90': itemDisplayed == index }"
                name="chevron-right"
              />
            </div>
            <div class="col-span-10 text-base line-clamp-3">
              {{ item.name }}
            </div>
          </div>
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              v-show="itemDisplayed === index"
              class="bg-white my-5 w-full relative flex flex-col space-y-4 px-5"
            >
              <TextToSpeech
                class="self-center"
                :speak="item.name"
              ></TextToSpeech>

              <input-text-area
                libelle="Intitulé"
                :value="item.name"
                :disabled="true"
                :size="3"
              />

              <input-select
                v-if="(!hiddenFields['auto_' + name] || historyMode) && !jauge"
                :name="num + name + index + 'auto'"
                :disabled="autoEvalEditable || historyMode"
                :datas="getCriteria(true)"
                :value="form.items.activities[num][name][index].auto"
                @input="
                  (newValue) => {
                    setAutoEvaluation(num, name, index, newValue);
                  }
                "
                libelle="Auto-évaluation"
                libelle-style="text-base text-indigo-600"
                :libelle-icon="
                  historyMode
                    ? null
                    : hiddenFields['auto_' + name]
                    ? 'eye-off'
                    : 'eye'
                "
                @clickIcon="
                  $can('comppro_auto_eval_read', idPass)
                    ? hide('auto_' + name)
                    : null
                "
              />

              <input-select
                v-if="(hiddenFields['auto_' + name] && !historyMode) && !jauge"
                :name="num + name + index + 'auto'"
                :disabled="true"
                :datas="getCriteria(true)"
                :value="''"
                libelle="Auto-évaluation"
                libelle-style="text-base text-indigo-600"
                :libelle-icon="
                  historyMode
                    ? null
                    : hiddenFields['auto_' + name]
                    ? 'eye-off'
                    : 'eye'
                "
                @clickIcon="
                  $can('comppro_auto_eval_read', idPass)
                    ? hide('auto_' + name)
                    : null
                "
              />

              <AnswerJauge
                v-if="!hiddenFields['auto_' + name] && jauge"
                class="md:col-span-2"
                :disabled="false"
                :criteria="getCriteria(true)"
                :reduced="false"
                :selected="form.items.activities[num][name][index].auto"
                @select="
                (newValue) => {
                  setAutoEvaluation(
                    num,
                    name,
                    index,
                    newValue !== undefined ? getCriteria(true)[newValue].value : undefined
                  );
                }
              "
                libelle="Auto-évaluation"
                libelle-style="text-base text-indigo-600"
                :libelle-icon="
                  historyMode
                    ? null
                    : hiddenFields['auto_' + name]
                    ? 'eye-off'
                    : 'eye'
                "
                @clickIcon="
                  $can('comppro_auto_eval_read', idPass)
                    ? hide('auto_' + name)
                    : null
                "
              ></AnswerJauge>

              <AnswerJauge
                v-if="hiddenFields['auto_' + name] && jauge"
                class="md:col-span-2"
                :disabled="true"
                :criteria="getCriteria(true)"
                :reduced="false"
                libelle="Auto-évaluation"
                libelle-style="text-base text-indigo-600"
                :libelle-icon="
                  historyMode
                    ? null
                    : hiddenFields['auto_' + name]
                    ? 'eye-off'
                    : 'eye'
                "
                @clickIcon="
                  $can('comppro_auto_eval_read', idPass)
                    ? hide('auto_' + name)
                    : null
                "
              ></AnswerJauge>

              <input-text
                v-if="!historyMode"
                :name="index + 'derniere_eval'"
                :disabled="true"
                :value="
                  hiddenFields['last_' + name]
                    ? ''
                    : (((latestEval || {}).items || {}).activities || [])
                        .length > 0
                    ? (
                        (((((latestEval || {}).items || {}).activities || [])[
                          num
                        ] || {})[name] || [])[index] || {}
                      ).value === null
                      ? 'Non noté'
                      : (
                          (((((latestEval || {}).items || {}).activities || [])[
                            num
                          ] || {})[name] || [])[index] || {}
                        ).value || 'Pas d\'évaluation récente'
                    : 'Pas d\'évaluation récente'
                "
                libelle="Dernière évaluation du référent"
                libelle-style="text-base text-indigo-600"
                :libelle-icon="hiddenFields['last_' + name] ? 'eye-off' : 'eye'"
                @clickIcon="hide('last_' + name)"
              />

              <input-select
                :class="{ hidden: idPass == idUser }"
                :name="num + name + index"
                :necessary="isNecessary"
                :datas="getCriteria(false)"
                :value="form.items.activities[num][name][index].value"
                @input="
                  (newValue) => {
                    setReferentEvaluation(num, name, index, newValue);
                  }
                "
                :disabled="idPass == idUser || historyMode"
                libelle="Nouvelle évaluation du référent"
                libelle-style="text-base text-indigo-600"
              />

              <input-text-area
                :name="'comment-' + num + '-' + name + '-' + index"
                libelle="Commentaire"
                :value="form.items.activities[num][name][index].comment"
                :size="3"
                @input="
                  (newValue) => {
                    setComment(num, name, index, newValue);
                  }
                "
                :disabled="historyMode"
              />
            </div>
          </transition>
        </div>
      </div>
      <!-- END display on rows (for MOBILE devices) -->
    </div>
  </div>
</template>

<script>
import InputSelect from './../Inputs/InputSelect.vue';
import InputText from './../Inputs/InputText.vue';
import IconComment from './../Inputs/IconComment.vue';
import InputTextArea from './../Inputs/InputTextArea.vue';
import Icon from './../Icon.vue';
import TextToSpeech from '../TextToSpeech.vue';
import AnswerJauge from '../Inputs/Jauge/AnswerJauge.vue';
import CheckboxIndigo from '../Inputs/CheckboxIndigo.vue';

export default {
  components: {
    CheckboxIndigo,
    AnswerJauge,
    TextToSpeech,
    InputSelect,
    IconComment,
    InputText,
    Icon,
    InputTextArea,
  },
  props: {
    category: {
      type: Array,
      required: false,
      default: [],
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    idPass: {
      type: String,
      required: false,
      default: '',
    },
    idUser: {
      type: Number,
    },
    hiddenFields: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    num: {
      type: Number,
    },
    form: {
      type: Object,
      required: false,
      default: {},
    },
    latestEval: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    isNecessary: {
      type: Boolean,
      required: false,
      default: false,
    },
    historyMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      itemDisplayed: -1,
      jauge: false,
    };
  },

  methods: {
    toggleJauge() {
      this.jauge = !this.jauge;
    },

    setAutoEvaluation(num, name, index, newValue) {
      this.$emit('setAutoEvaluation', num, name, index, newValue);
    },
    setReferentEvaluation(num, name, index, newValue) {
      this.$emit('setReferentEvaluation', num, name, index, newValue);
    },
    setComment(num, name, index, newValue) {
      this.$emit('setComment', num, name, index, newValue);
    },
    hide(field) {
      this.$emit('hideField', field);
    },

    displayItem(index, name) {
      if (this.itemDisplayed == index) {
        this.itemDisplayed = -1;
      } else {
        this.itemDisplayed = index;
        let pos = document.getElementById('category' + name + index);
        setTimeout(() => {
          pos.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 800);
      }
    },

    getCriteria(firstPerson = true) {
      const criteria = this.form.template.filter(
        (temp) => temp.libelle === "Critères d'évaluation"
      )[0].criterions;

      let initialCriteria = [];

      if (this.historyMode) {
        initialCriteria = [...criteria];
      }

      let isConjugable = false;

      for (const criterion of criteria) {
        if (
          criterion.value.startsWith('Je') ||
          criterion.value.startsWith('J’')
        ) {
          isConjugable = true;
          break;
        }
      }

      if (isConjugable && firstPerson) {
        return criteria;
      }

      if (isConjugable && !firstPerson) {
        return [
          ...initialCriteria,
          ...criteria.map((criterion) => {
            let value = criterion.value;
            value = value
              .replace('Je', 'Il')
              .replace('J’', 'Il ')
              .replace('me', 'se')
              .replace('m’', 's’')
              .replace('sais', 'sait')
              .replace('apprends', 'apprend')
              .replace('peux', 'peut');
            return {
              value: value,
            };
          }),
        ];
      }

      return criteria;
    },
  },
  computed: {
    listCriterions() {
      return this.form.template.filter(
        (temp) => temp.libelle === "Critères d'évaluation"
      )[0].criterions;
    },
    autoEvalEditable() {
      let isNeopassOwner = parseInt(this.idPass) === this.idUser,
        canEdit = this.$can('comppro_auto_eval_edit', this.idPass);
      return !(!isNeopassOwner ^ !canEdit);
    },
  },
};
</script>
